/**
 * Effective tier capability matrix for the Admin Users page.
 * Values: true = included, false = not included, 'partial' = limited access.
 */

export const TIER_COLUMNS = [
  { id: 'basic', label: 'Basic', grant: 'Default (signed in, no Pro subscription)' },
  { id: 'pro', label: 'Pro', grant: 'Whop RiskLo Pro or Dev Pro list' },
  { id: 'max', label: 'Max', grant: 'Dev Max list (Whop Max planned)' },
  { id: 'vadmin', label: 'Brand Admin', grant: 'Brand Admin list' },
  { id: 'vadminPlus', label: 'Brand Admin Plus', grant: 'Brand Admin Plus list' },
  { id: 'admin', label: 'Platform Admin', grant: 'Platform Admin list' },
];

/** Rows grouped for readability in the comparison table. */
export const TIER_CAPABILITY_GROUPS = [
  {
    title: 'Results & analysis',
    rows: [
      {
        label: 'Overview dashboard (view)',
        basic: true, pro: true, max: true, vadmin: true, vadminPlus: true, admin: true,
        note: 'Basic views the brand dashboard read-only.',
      },
      {
        label: 'Personal Overview dashboards (create & customize)',
        basic: false, pro: true, max: true, vadmin: true, vadminPlus: true, admin: true,
      },
      {
        label: 'Results — Current Results view',
        basic: true, pro: true, max: true, vadmin: true, vadminPlus: true, admin: true,
      },
      {
        label: 'Results — strategy & summary views (calendar, chart, spreadsheet)',
        basic: true, pro: true, max: true, vadmin: true, vadminPlus: true, admin: true,
      },
      {
        label: 'Results — detailed KPI metrics',
        basic: false, pro: true, max: true, vadmin: true, vadminPlus: true, admin: true,
        note: 'KPI stats block is blurred for Basic with an upgrade prompt.',
      },
      {
        label: 'Custom Multi-Strat combos',
        basic: false, pro: true, max: true, vadmin: true, vadminPlus: true, admin: true,
      },
      {
        label: 'Brand strategy data',
        basic: false, pro: true, max: true, vadmin: true, vadminPlus: true, admin: true,
        note: 'Live strategy data requires an active brand membership (Whop). Dev Basic list grants sheet data while keeping Basic UI.',
      },
      {
        label: 'Portfolio Simulator',
        basic: false, pro: true, max: true, vadmin: true, vadminPlus: true, admin: true,
      },
      {
        label: 'My Results (NinjaTrader dashboard)',
        basic: false, pro: false, max: false, vadmin: false, vadminPlus: false, admin: true,
      },
      {
        label: 'My Portfolio (broker sync & reporting)',
        basic: false, pro: true, max: true, vadmin: true, vadminPlus: true, admin: true,
        note: 'Pro sees only linked accounts; Max and above can view all accounts.',
      },
    ],
  },
  {
    title: 'Risk tools (home)',
    rows: [
      {
        label: 'Account Blowout Risk (single account)',
        basic: false, pro: true, max: true, vadmin: true, vadminPlus: true, admin: true,
      },
      {
        label: '% Rule Risk (single account)',
        basic: false, pro: true, max: true, vadmin: true, vadminPlus: true, admin: true,
      },
      {
        label: 'Bulk Risk Calculator',
        basic: false, pro: true, max: true, vadmin: true, vadminPlus: true, admin: true,
      },
      {
        label: 'NinjaTrader CSV upload tab',
        basic: false, pro: true, max: true, vadmin: true, vadminPlus: true, admin: true,
      },
      {
        label: 'Hedging Risk (futures strategy pair analysis)',
        basic: 'partial', pro: true, max: true, vadmin: true, vadminPlus: true, admin: true,
        note: 'Basic sees one example hedging pair; Pro unlocks all strategy pairings.',
      },
    ],
  },
  {
    title: 'Account',
    rows: [
      {
        label: 'Email summaries after CSV analysis',
        basic: false, pro: true, max: true, vadmin: true, vadminPlus: true, admin: true,
      },
      {
        label: 'Bypass Whop subscription checks',
        basic: false, pro: false, max: 'partial', vadmin: true, vadminPlus: true, admin: true,
        note: 'Max via Dev Max list only today; Admin tiers and Brand Admin bypass.',
      },
    ],
  },
  {
    title: 'Admin tools',
    rows: [
      {
        label: 'Edit brand (Overview) dashboard',
        basic: false, pro: false, max: false, vadmin: true, vadminPlus: true, admin: true,
      },
      {
        label: 'Arrange Results tabs',
        basic: false, pro: false, max: false, vadmin: true, vadminPlus: true, admin: true,
      },
      {
        label: 'Strategy Data editor',
        basic: false, pro: false, max: false, vadmin: true, vadminPlus: true, admin: true,
      },
      {
        label: 'Webhooks (NT8, Kairos, TradingView, Fyntrak)',
        basic: false, pro: false, max: false, vadmin: true, vadminPlus: true, admin: true,
      },
      {
        label: 'Users page (view allowlists)',
        basic: false, pro: false, max: false, vadmin: true, vadminPlus: true, admin: true,
      },
      {
        label: 'Users page (add / edit emails)',
        basic: false, pro: false, max: false, vadmin: false, vadminPlus: true, admin: true,
        note: 'Brand Admin Plus cannot edit the Admin allowlist.',
      },
      {
        label: 'Users page (remove emails)',
        basic: false, pro: false, max: false, vadmin: false, vadminPlus: false, admin: true,
      },
      {
        label: 'Equity Strategies editor',
        basic: false, pro: false, max: false, vadmin: false, vadminPlus: false, admin: true,
      },
      {
        label: 'Change Logs',
        basic: false, pro: false, max: false, vadmin: true, vadminPlus: true, admin: true,
      },
      {
        label: 'Strategy simulator page',
        basic: false, pro: false, max: false, vadmin: false, vadminPlus: false, admin: true,
      },
    ],
  },
];
